/// <reference path="../../components/commonClasses/common.interface.ts" />
/// <reference path="../../components/commonClasses/commonDataServiceBase.ts" />

module Meevo.Components.Common {
    export class TechSphereService extends Meevo.Components.CommonClasses.CommonDataServiceBase implements Meevo.Components.CommonClasses.ICommonDataService {
        constructor(protected appSettings: Meevo.Components.Common.IAppSettings, protected $http: angular.IHttpService) {
            super(appSettings, $http);
        }


        static factory(): Function {
            let svc = (appSettings: Meevo.Components.Common.IAppSettings, $http: angular.IHttpService) => {
                return new TechSphereService(appSettings, $http);
            }

            svc.$inject = ["meevo.AppSettings", "$http"];
            return svc;
        }
    }

    angular.module("meevo.components.common")
        .factory("meevo.components.common.TechSphereService", TechSphereService.factory());
}